import { buildSelector } from '@/shared/lib/store';

export const [useSelectedPatternWatchlistId] = buildSelector(
    (state) => state.patternWatchlist?.selectedPatternWatchlistId ?? null,
);
